import React, { useEffect, useState } from 'react'
import PasswordRule from './PasswordRule.jsx'

function PasswordValidator({ passwordInput, username, onValidate }) {
  const [rules, setRules] = useState([
    {
      name: '8-240 characters',
      func: (password) => {
        const passwordLength = password.length
        return passwordLength >= 8 && passwordLength <= 240
      },
      valid: false,
    },
    {
      name: 'At least one lowercase letter',
      func: (password) => {
        const alphaRegex = /[a-z]/
        return alphaRegex.test(password)
      },
      valid: false,
    },
    {
      name: 'At least one uppercase letter',
      func: (password) => {
        const alphaRegex = /[A-Z]/
        return alphaRegex.test(password)
      },
      valid: false,
    },
    {
      name: 'At least one number',
      func: (password) => {
        var numberRegex = /[0-9]/
        return numberRegex.test(password)
      },
      valid: false,
    },
    {
      name: 'At least one special character (ex. ! & # $ @)',
      func: (password) => {
        return (
          password.indexOf('!') >= 0 ||
          password.indexOf('&') >= 0 ||
          password.indexOf('#') >= 0 ||
          password.indexOf('$') >= 0 ||
          password.indexOf('@') >= 0
        )
      },
      valid: false,
    },
    {
      name: 'Word "password" not included',
      func: (password) => {
        return password.toLowerCase().indexOf('password') < 0
      },
      valid: false,
    },
    {
      name: 'No repeating characters (ex. 111, aaa, !!!)',
      func: (password) => {
        const repeat3Regex = /(.)\1{2}/
        return !repeat3Regex.test(password)
      },
      valid: false,
    },
    {
      name: 'Your password cannot contain more than 3 characters of your User ID',
      func: (password, username) => {
        return !matchUsernamePassword(username, password)
      },
      valid: false,
    },
    {
      name: 'No spaces',
      func: (password) => {
        return password.indexOf(' ') < 0
      },
      valid: false,
    },
  ])

  useEffect(() => {
    const _rules = [...rules]
    _rules.forEach((rule) => {
      rule.valid = rule.func(passwordInput, username)
    })
    setRules(_rules)
    onValidate(!_rules.find((rule) => !rule.valid))
  }, [passwordInput])

  return (
    <>
      {rules.map((rule) => {
        return <PasswordRule key={rule.name} rule={rule} />
      })}
    </>
  )
}

PasswordValidator.propTypes = {}

export default PasswordValidator

function matchUsernamePassword(username, password) {
  username = username.toLowerCase()
  password = password.toLowerCase()

  var found = false
  var MAX_MATCHING_CHARS = 4

  // O(n^2). Code challenge! Make this O(n log n) or better
  for (var i = 0; i < username.length; i++) {
    for (var j = 0; j < password.length; j++) {
      // iterate through each character, compare the next 5 chars, if they all match, we win
      // any place we dont match, break out the loop early to save on performance
      for (var k = 0; k < MAX_MATCHING_CHARS; k++) {
        if (username[i + k]) {
          if (password[j + k]) {
            var uNext = username[i + k]
            var pNext = password[j + k]

            if (uNext === pNext) {
              found = true
            } else {
              found = false
              break
            }
          } else {
            found = false
            break
          }
        } else {
          found = false
          break
        }
      }

      if (found) {
        return true
      }
    }
  }
  return false
}
